import { mapState } from "vuex";

var ShortCutKeys = {
  created: function() {
    // this.fetchAllShortCuts();
  },
  methods: {
    fetchAllShortCuts() {
      this.$store.dispatch("masterData/FetchAllShortCuts");
    },
  },
  computed: {
    // ...mapState("masterData", ["shortcuts"]),
    ...mapState("masterData", {
      sck: (state) => state.shortcuts,
    }),
  },
};

export default ShortCutKeys;
